import type { SVGProps } from "react";
export const Delete = (props: SVGProps<SVGSVGElement>) => (
	<svg
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		aria-hidden={true}
		{...props}
	>
		<path
			d="M5.5 20.5V5.99999H4.5V4.49999H9V3.61549H15V4.49999H19.5V5.99999H18.5V20.5H5.5ZM7 19H17V5.99999H7V19ZM9.404 17H10.9037V7.99999H9.404V17ZM13.0962 17H14.596V7.99999H13.0962V17Z"
			fill="currentColor"
		/>
	</svg>
);
